//SET ERROR STATE


export const setErrorState = (code, message) => ({
    type : 'SET_ERROR_STATE',
    code,
    message
});






// WEBPACK FOOTER //
// ./src/Actions/errorHandler.js